import { RpcClient } from '../../../services/rpc-socket/rpcClient';
import { TSetDialogResult } from './types/create-dialog.interface';

export const setCreateDialogResult = (request: TSetDialogResult) => {
  return RpcClient.call('setDialogResult', request) as Promise<boolean>;
};
